import {
  Alert,
  Button,
  Card,
  CardActions,
  CardContent,
  IconButton,
} from "@mui/material";
import { trashStyles } from "../../../context/customStyles";
import {
  AddCircleRounded,
  Delete,
  DownloadForOfflineRounded,
} from "@mui/icons-material";
import CustomDropDown from "../../Custom/CustomDropDown";
import NoListItems from "../../Custom/NoListItems";
import DisplayCards from "../../DisplayItems/DisplayCards";
import CustomTextField from "../../Custom/CustomTextField";
import FileField from "../../Custom/FileField";
import ListLoader from "../../DisplayItems/SkeletonLoaders/ListLoader";

const ModDeckContent = ({
  deckId,
  deleting,
  setDeleting,
  handleDelete,
  deck,
  setDeck,
  setChangesMade,
  changesMade,
  categoryOptions,
  file,
  setFile,
  saving,
  handleSave,
  loading,
  parseFile,
  setCardModal,
  visibleCards,
  cards,
  setIndex,
}) => {
  return (
    <div className="page-box">
      <Card
        className="card-page"
        sx={{
          boxShadow: "var(--box-shadow)",
          borderRadius: "var(--borderRadius)",
        }}
      >
        <div className="header">
          <h1>{deckId !== "new" ? "Edit Deck" : "New Deck"}</h1>
          {deckId !== "new" && (
            <IconButton
              style={trashStyles}
              color="error"
              className="icon-button"
              onClick={() => setDeleting(true)}
            >
              <Delete fontSize="inherit" color="error" />
            </IconButton>
          )}
        </div>
        <CardContent className="card-content">
          {deleting ? (
            <Alert
              type="error"
              severity="error"
              color="error"
              variant="filled"
              className="card-alert"
              sx={{
                "& .MuiAlert-action": {
                  padding: 0,
                  gap: 1,
                  alignItems: "center",
                },
              }}
              action={[
                <Button
                  color="ghostBlack"
                  variant="contained"
                  disableElevation
                  className="px-4 py-1"
                  key="cancel"
                  onClick={() => setDeleting(false)}
                >
                  Cancel
                </Button>,
                <Button
                  color="ghostRed"
                  variant="contained"
                  disableElevation
                  className="px-4 py-1"
                  key="delete"
                  onClick={handleDelete}
                >
                  Delete
                </Button>,
              ]}
            >
              Are you sure you would like to delete this deck?
            </Alert>
          ) : (
            <Alert
              type="error"
              severity="error"
              color="error"
              className="card-alert"
              variant="filled"
            >
              All changes made to the deck and cards need to be saved below
            </Alert>
          )}

          <div className="rows">
            <div className="content-group">
              <h4 className="italic-subtitle">Deck Details</h4>
              <form className="d-flex gap-2 flex-column">
                <CustomDropDown
                  label="Category"
                  color="black"
                  fullWidth
                  required
                  value={deck.category}
                  onChange={(e) => {
                    setDeck({ ...deck, category: e.target.value });
                    setChangesMade({ ...changesMade, deck: true });
                  }}
                  options={categoryOptions}
                />
                <CustomTextField
                  color="black"
                  label="Title"
                  inputProps={{ maxLength: 50 }}
                  error={deck && !deck.name && changesMade.deck}
                  required
                  fullWidth
                  value={deck ? deck.name : ""}
                  onChange={(e) => {
                    setDeck({ ...deck, name: e.target.value });
                    setChangesMade({ ...changesMade, deck: true });
                  }}
                />
                <CustomTextField
                  color="black"
                  label="Subtitle"
                  inputProps={{ maxLength: 20 }}
                  error={deck && !deck.subtitle && changesMade.deck}
                  required
                  fullWidth
                  value={deck ? deck.subtitle : ""}
                  onChange={(e) => {
                    setDeck({ ...deck, subtitle: e.target.value });
                    setChangesMade({ ...changesMade, deck: true });
                  }}
                />
              </form>
            </div>
            <hr style={{ margin: 0 }} />
            <div className="content-group">
              <h4 className="italic-subtitle">
                <div>Cards Upload</div>
                <Button
                  color="ghostBlue"
                  variant="contained"
                  className="py-1 button-link"
                  startIcon={<DownloadForOfflineRounded color="inherit" />}
                  disableElevation
                  href="https://docs.google.com/spreadsheets/d/1P_Xs24AJ_tVRLn9XQGHbft1lVT_1qO16ACVWaSqHmVI/export?gid=0&format=csv"
                  download="new_flashcards_upload"
                >
                  Save Template
                </Button>
              </h4>
              <div className="container-box d-flex gap-2 flex-column">
                <form
                  style={{
                    width: "100%",
                  }}
                >
                  <FileField
                    selectedFile={file}
                    setSelectedFile={setFile}
                    onAutoSubmit={(newFile) => parseFile(newFile)}
                  />
                </form>
              </div>
            </div>
          </div>
          <hr />

          <div className="content-group pb-0" id="cards">
            <h4 className="italic-subtitle">
              <div>Cards</div>
              <Button
                color="ghostBlue"
                variant="contained"
                disabled={loading}
                className="py-1"
                startIcon={<AddCircleRounded color="inherit" />}
                disableElevation
                onClick={() => setCardModal("active")}
              >
                Add Card
              </Button>
            </h4>
            <div className="container-box cards">
              {visibleCards.length === 0 && !loading && (
                <NoListItems
                  text="Add a card above"
                  customHeight="calc(100dvh + 33.5rem)"
                />
              )}
              {loading && <ListLoader count={3} />}
              {cards && cards.length > 0 && (
                <DisplayCards
                  cards={cards}
                  setOpen={setCardModal}
                  setIndex={setIndex}
                />
              )}
            </div>
          </div>
        </CardContent>
        <CardActions className="float-actions">
          <Button
            href={"/flashcards"}
            size="large"
            color="ghostBlack"
            variant="contained"
            disableElevation
            sx={{ width: "8rem" }}
            className="py-2 nav-link"
          >
            cancel
          </Button>
          <Button
            size="large"
            color="black"
            variant="contained"
            disabled={
              !deck.name ||
              !deck.category ||
              saving ||
              (changesMade.deck === false && changesMade.cards === false)
            }
            disableElevation
            onClick={handleSave}
            sx={{ width: "8rem", marginLeft: 0 }}
            className="py-2"
          >
            {saving ? "Saving ..." : "Save"}
          </Button>
        </CardActions>
      </Card>
    </div>
  );
};

export default ModDeckContent;
